import React, { useContext, useEffect, useState } from 'react';
import {
  SitecoreContext,
  withSitecoreContext,
  WithSitecoreContextProps,
} from '@sitecore-jss/sitecore-jss-react';

import './index.scss';
import { ProductDataContext, ProductContextType } from '../../../context/productContext';
import DOMPurify from 'dompurify';

type ProductDescriptionSectionProps = WithSitecoreContextProps & {
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
  config: {
    isTrainingCourse: boolean;
  };
};

const ProductDescriptionSection = ({
  sitecoreContext,
  config,
}: ProductDescriptionSectionProps): React.JSX.Element => {
  const { productDetail } = useContext(ProductDataContext) as ProductContextType;
  const [description, setDescription] = useState<string>('');

  useEffect(() => {
    if (productDetail?.productMetaData?.description) {
      const desc =
        config?.isTrainingCourse || productDetail.productMetaData.description.length < 1000
          ? productDetail.productMetaData.description
          : productDetail.productMetaData.description.substring(0, 1000) + '...';

      setDescription(DOMPurify.sanitize(desc));
    } else {
      setDescription('');
    }
  }, [productDetail]);

  return (
    <div className="productdescriptionsection">
      {sitecoreContext.pageEditing && (
        <>
          <p>ProductDescriptionSection Component Edit Mode</p>
        </>
      )}
      <span className="productdescriptionheader">Description</span>
      {description && (
        <div className="productdescription" dangerouslySetInnerHTML={{ __html: description }} />
      )}
    </div>
  );
};

export default withSitecoreContext()(ProductDescriptionSection);
